module.exports = __webpack_public_path__ + "img/logo-cmc vision colored (1).130929fb.svg";